let runtimeAccessToken = "";
let isBridgeInitialized = false;
let accessTokenListeners = [];

function parseAllowedOrigins(origins = "") {
    return String(origins)
        .split(",")
        .map(o => o.trim())
        .filter(Boolean);
}

export function setAccessToken(token) {
    runtimeAccessToken = String(token || "").trim();
    if (runtimeAccessToken) {
        accessTokenListeners.forEach(fn => fn(runtimeAccessToken));
        accessTokenListeners = [];
    }
}

export function getAccessToken() {
    return runtimeAccessToken || localStorage.getItem("accessToken") || "";
}

export function clearAccessToken() {
    runtimeAccessToken = "";
}

export function initAccessTokenBridge(options = {}) {
    if (isBridgeInitialized) {
        return;
    }

    const configuredOrigins = Array.isArray(options.allowedOrigins) ?
        options.allowedOrigins :
        parseAllowedOrigins(import.meta.env.VITE_IFRAME_ALLOWED_ORIGINS);

    const allowedOrigins = configuredOrigins.map(o => o.trim()).filter(Boolean);

    window.addEventListener("message", e => {
        if (allowedOrigins.length && !allowedOrigins.includes(e.origin)) {
            return;
        }

        const data = e.data || {};
        const token =
            data.token ||
            data.accessToken ||
            (data.type === "token" ? data.data : undefined);

        if (typeof token === "string" && token.trim()) {
            setAccessToken(token);
        }
    });

    isBridgeInitialized = true;
}

export function waitForAccessToken(timeout = 1500) {
    const token = getAccessToken();
    if (token) {
        return Promise.resolve(token);
    }

    return new Promise(resolve => {
        const timer = setTimeout(() => {
            accessTokenListeners = accessTokenListeners.filter(fn => fn !== onToken);
            resolve(getAccessToken());
        }, timeout);

        const onToken = () => {
            clearTimeout(timer);
            resolve(getAccessToken());
        };

        accessTokenListeners.push(onToken);
    });
}
